import { Button } from 'components/atomic'
import Image from 'next/legacy/image'
import Link from 'next/link'
import { useRouter } from 'next/router'

interface SwitchProfileProps {
  isFounderProfile: boolean
}
const SwitchProfile = ({ isFounderProfile }: SwitchProfileProps) => {
  const { pathname } = useRouter()

  return (
    <div className="pb-12 pt-36 lg:pt-48">
      <div className="flex flex-col items-center justify-center space-y-12 lg:flex-row">
        <div className="flex w-full skew-x-[-20deg] justify-center">
          <Link
            href="/general-profile"
            className={`flex h-12 w-48 items-center justify-center border border-solid px-2 text-base font-semibold uppercase leading-5 tracking-wide ${
              pathname === '/general-profile' ? 'border border-none bg-primary text-black' : 'border-white text-white'
            }`}
          >
            <span className="skew-x-[20deg] text-center">Profile Page</span>
          </Link>
          <div className="mx-1 h-12 w-2 bg-primary" />
          {isFounderProfile ? (
            <Link
              href="/founder-profile"
              passHref
              className={`flex h-12 w-48 items-center justify-center border border-solid px-2 text-base font-semibold uppercase leading-5 tracking-wide ${
                pathname === '/founder-profile' ? 'border-none bg-primary text-black' : 'border-white text-white'
              }`}
            >
              <span className="skew-x-[20deg] text-center">Founder Profile</span>
            </Link>
          ) : (
            <div className="pointer-events-none flex h-12 w-48 items-center justify-center bg-[#454340] text-base font-semibold uppercase leading-5 tracking-wide text-black">
              <span className="skew-x-[20deg] text-center">Founder Profile</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SwitchProfile
